export default function AdditionalTermsDialog() {
  return (
    <div>
      <h3 className='h3'>Einwilligung in die Verwendung personenbezogener Daten</h3>
      <p className='p'>
        <b className='b'>1.</b> Ich willige ein, dass mein Vor- und Zuname, meine E-Mail-Adresse und meine Telefonnummer
        (Basisdaten) und die im Formular auf der Internetseite www.hartz4widerspruch.de gemachten freiwilligen Angaben
        zu Zwecken der Marktforschung sowie zur individuellen Erstellung und Versendung ausgewählter Informationen per
        Post (ggf. per E-Mail) sowie Kontaktaufnahme per Telefon durch Rechtsanwalt Olaf Schubert, Berliner Straße 2,
        15566 Schöneiche bei Berlin verwendet werden. Ferner willige ich ein, dass die Mathis Ruff
        Rechtsanwaltsgesellschaft mbH, vertreten durch ihre Geschäftsführer Rechtsanwälte Mathis Ruff und Mathias Voigt,
        Greifswalder Straße 207, 10405 Berlin meine Basisdaten und freiwilligen Angaben zu eigenen Zwecken der
        Marktforschung verwendet.
      </p>
      <p className='p'>
        <b className='b'>2.</b> Diese Einwilligung kann ich jederzeit mit Wirkung für die Zukunft gegenüber der Mathis
        Ruff Rechtsanwaltsgesellschaft mbH, vertreten durch ihre Geschäftsführer Rechtsanwälte Mathis Ruff und Mathias
        Voigt, Greifswalder Straße 207, 10405 Berlin, E-Mail:
        <a className='a' href='mailto:kanzlei@rechtsanwalt-ruff.de'>
          kanzlei@rechtsanwalt-ruff.de
        </a>
        , Fax: 030 / 22 066 23 89 widerrufen.
      </p>
      <p className='p'>
        <b className='b'>3.</b> Ich weiß, dass die Leistungen der Mathis Ruff Rechtsanwaltsgesellschaft mbH, vertreten
        durch ihre Geschäftsführer Rechtsanwälte Mathis Ruff und Mathias Voigt, Greifswalder Straße 207, 10405 Berlin,
        unabhängig davon erbracht werden, ob ich meine Einwilligung erkläre oder widerrufe.
      </p>
      <p className='p'>
        <b className='b'>4.</b> Den Inhalt der Einwilligung kann ich jederzeit bei der Mathis Ruff
        Rechtsanwaltsgesellschaft mbH, vertreten durch ihre Geschäftsführer Rechtsanwälte Mathis Ruff und Mathias Voigt,
        Greifswalder Straße 207, 10405 Berlin, per E-Mail (
        <a className='a' href='mailto:kanzlei@rechtsanwalt-ruff.de'>
          kanzlei@rechtsanwalt-ruff.de
        </a>
        ) anfordern.
      </p>
    </div>
  );
}
